import { render, staticRenderFns } from "./ContratoAssinaturaAlocacao.vue?vue&type=template&id=ca048e84&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./ContratoAssinaturaAlocacao.vue?vue&type=script&lang=js&"
export * from "./ContratoAssinaturaAlocacao.vue?vue&type=script&lang=js&"
import style0 from "./ContratoAssinaturaAlocacao.vue?vue&type=style&index=0&id=ca048e84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca048e84",
  null
  
)

export default component.exports